import React from "react";

import publicConfig from "@/config/public";

import { SailthruMetaTags } from "@/components/brands/SailthruMetaTags";
import MetaTags from "@/components/MetaTags";

const DEFAULT_TITLE = "THC & CBD Products Online by the Best Brands | Leafly";
const DEFAULT_DESCRIPTION =
  "Shop the top THC, CBD, Delta 8 products online from Leafly. Browse a variety of cannabis products like flower, edibles, growing kits, seeds, & more.";
const DEFAULT_IMAGE = `${publicConfig.imgix.publicUrl}/consumer-web/products/products-brands-shortC.jpg`;

export const ProductCategoryMetaTags: React.FC<{
  canonicalOverride?: string;
  canonicalParams?: string[];
  description?: string;
  image?: string | boolean;
  robots?: string;
  shouldShowAlternates?: boolean;
  title?: string;
}> = ({
  canonicalOverride,
  canonicalParams = [],
  description,
  image,
  robots,
  shouldShowAlternates,
  title,
}) => {
  return (
    <>
      <MetaTags
        canonicalOverride={canonicalOverride}
        canonicalParams={canonicalParams}
        description={description || DEFAULT_IMAGE}
        image={`${image}?auto=compress&fit=fill&fill=solid&w=1200&h=630&fm=jpg`}
        robots={robots}
        shouldShowAlternates={shouldShowAlternates}
        title={title || DEFAULT_TITLE}
      />
      <SailthruMetaTags
        description={description || DEFAULT_DESCRIPTION}
        title={title || DEFAULT_TITLE}
        tags={[title || DEFAULT_TITLE]}
      />
    </>
  );
};
